import { HTMLRenderer } from 'common/html-renderer.js';
import { GeneralHeaderInformationComponent, GeneralHeaderInformationComponentProps } from './general-headers.js';

interface GeneralInfoCompProps {
  text: string[] | string;
  headers: GeneralHeaderInformationComponentProps[];
  issuedAt?: string;
}

export const GeneralInformationComponent = ({ headers, issuedAt, text }: GeneralInfoCompProps) => {
  const finalText = Array.isArray(text) ? text : [text];

  return (
    <>
      <GeneralHeaderInformationComponent headers={headers} />

      {finalText.map((text, index) => {
        return <HTMLRenderer classes="u-mT-responsive" key={index} content={text} />;
      })}

      {issuedAt && (
        <p className="fineprint u-textGrey u-mT-sm u-mB-0">
          <span className="u-textBold">Issued: </span>
          {issuedAt}
        </p>
      )}
    </>
  );
};
